import { render, staticRenderFns } from "./VFirstLoginAuthorizationGuidePopUp.vue?vue&type=template&id=5682911c&scoped=true&"
import script from "./VFirstLoginAuthorizationGuidePopUp.vue?vue&type=script&lang=js&"
export * from "./VFirstLoginAuthorizationGuidePopUp.vue?vue&type=script&lang=js&"
import style0 from "./VFirstLoginAuthorizationGuidePopUp.vue?vue&type=style&index=0&id=5682911c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682911c",
  null
  
)

export default component.exports